import { fromIso9075DateString, getIso9075DateString } from 'utils/dates';

//  ---------------------------------
//  huge ugly hack!
let SERVER_TIME_DIFF = false;

const timeLeft = function () {
  return this.drawTime.getTime() - Date.now() + this.serverTimeDiff;
};

//  ---------------------------------
const claimedWinners = function () {
  return (
    (this.drawingWinners && this.drawingWinners.drawingWinners) ||
    []
  ).filter(w => w.claimed);
};

//  ---------------------------------
const winnersWithPlaces = function () {
  let places = (this.winningPlaces && this.winningPlaces.winningPlaces) || [];

  return this.claimedWinners().map(w => {
    let place = places.find(p => p.place === w.rank);
    w.place = Object.assign({}, { prize: { name: '...', url: '' } }, place);
    return w;
  });
};

//  ---------------------------------
// [{
//   place: 1,
//   winner: {id, name},
//   prizes: [{id name url}, {id name url...} ...],
//   awarded: 'Awarded'|'Unclaimed'
// }, ...]
const placesWithPrizes = function () {
  let places = (this.winningPlaces && this.winningPlaces.winningPlaces) || [];

  const hash = [];
  let curr = {};
  places.forEach(p => {
    if (p.place !== curr.place) {
      const l = hash.push({
        place: p.place,
        winner: p.winner,
        prizes: [p.prize],
        //  simplified status
        awarded:
          p.awarded !== 'Unclaimed' && p.awarded !== 'Unplayed'
            ? 'Awarded'
            : 'Unclaimed'
      });
      curr = hash[l - 1];
    } else {
      curr.prizes.push(p.prize);
    }
  });

  return hash;
};

//  ---------------------------------
const prizeForRound = function (round) {
  let places = (this.winningPlaces && this.winningPlaces.winningPlaces) || [];
  round = round || this.currentRound || 1;
  let place = places.find(p => p.place === round) || {};
  return Object.assign({}, { name: '...', url: '' }, place.prize);
};

const prizesForRound = function (round) {
  round = round || this.currentRound || 1;
  return ((this.winningPlaces && this.winningPlaces.winningPlaces) || [])
    .filter(p => p.place === round)
    .map(p => Object.assign({ name: '...', url: '' }, p.prize));
};

//  same as the above with filtered out non-unique urls
const prizesForRoundUniq = function (round) {
  const hash = {};
  this.prizesForRound(round).forEach(p => {
    if (p.url && !hash[p.url]) {
      hash[p.url] = p;
    }
  });
  return Object.values(hash);
};

//  ---------------------------------
// {
//   "name": "Name",
//   "drawTime": "2019-07-29 15:39:00",
//   "winningPlaces": {
//     "winningPlaces": [{
//         "place": 1,
//         "prize": {
//           "name": "Massage",
//           "id": 84
//         }
//       },
//       {
//         "place": 1,
//         "prize": {
//           "name": "Hotel One Night",
//           "id": 138
//         }
//       }
//     ]
//   },
//   "id": "1993",
//   "drawingWinners": {
//     "drawingWinners": [{
//       "rank": 1,
//       "winnerAwardPrizeStatus": [{
//           "prizeId": 84,
//           "success": true
//         },
//         {
//           "prizeId": 138,
//           "success": true
//         }
//       ],
//       "claimed": true,
//       "user": {
//         "displayName": "pcitest34"
//       }
//     }]
//   }
// },

export const augmentDrawing = drawing => {
  let places =
    (drawing.winningPlaces && drawing.winningPlaces.winningPlaces) || [];
  drawing.firstPrize = (places[0] && places[0].prize) || {};
  drawing.totalPlaces = places.length ? places[places.length - 1].place : 0;

  drawing.currentRound =
    drawing.currentRound === undefined ? 0 : drawing.currentRound;
  drawing.lastEvent =
    drawing.lastEvent === undefined ? false : drawing.lastEvent;
  drawing.lastEventTimeMs =
    drawing.lastEventTimeMs === undefined ? false : drawing.lastEventTimeMs;
  drawing.lastWinnerName =
    drawing.lastWinnerName === undefined ? false : drawing.lastWinnerName;

  drawing.drawTime = fromIso9075DateString(drawing.drawTime);

  drawing.customDrumClosedTime =
    !drawing.allTicketsAllowed && drawing.customDrumClosedTime
      ? fromIso9075DateString(drawing.customDrumClosedTime)
      : null;

  if (drawing.lastModified) {
    drawing.lastModified = fromIso9075DateString(drawing.lastModified);
  }

  drawing.serverTimeDiff = -1;
  if (drawing.serverTime && drawing.drawingState === 'Upcoming') {
    if (SERVER_TIME_DIFF === false) {
      let st = parseFloat(drawing.serverTime);
      //  the serverTimeDiff shows how fast is local time relatively
      //  to the server time, negative value means slow
      SERVER_TIME_DIFF = isNaN(st) ? SERVER_TIME_DIFF : Date.now() - st;
    }
    drawing.serverTimeDiff = SERVER_TIME_DIFF || 1;
  }

  let history = [];
  if (
    drawing.drawingWinners &&
    drawing.drawingWinners.drawingWinners &&
    drawing.drawingWinners.drawingWinners.length
  ) {
    const hash = {};
    places.forEach(p => {
      if (!hash[p.place]) {
        hash[p.place] = [];
      }
      hash[p.place].push(p);
    });

    drawing.drawingWinners.drawingWinners =
      drawing.drawingWinners.drawingWinners.sort(
        (lhs, rhs) =>
          lhs.rank +
          (lhs.claimed | 0) * 0.1 -
          rhs.rank -
          (rhs.claimed | 0) * 0.1
      ); //  sorts by rank and claimed, unclaimeds go first

    drawing.drawingWinners.drawingWinners.forEach(w => {
      //  WCC-2036, "|| []" for that crazy situation when the drawing
      //  has winners but has NOT places
      const hPlaces = hash[w.rank] || [];

      if (!w.claimed) {
        hPlaces.forEach(p => (p.awarded = p.awarded || 'Unclaimed'));
        history = history.concat(
          hPlaces.map(hp => ({
            place: w.rank,
            prize: hp.prize.name,
            winner: w.user.displayName,
            patronAccountNumber: w.patronAccountNumber,
            awarded: 'Unclaimed',
            wintime: w.wintime
          }))
        );
        return;
      }

      //  below only for claimed
      const statuses = [...(w.winnerAwardPrizeStatus || [])];
      hPlaces.forEach(p => {
        p.winner = w.user; //  ties prizes to winner
        p.patronAccountNumber = w.patronAccountNumber;
        const idx = statuses.findIndex(s => s.prizeId === p.prize.id);
        let awarded = 'Unknown';
        if (idx !== -1) {
          awarded = (statuses[idx].success && 'Awarded') || 'Error';
          statuses.splice(idx, 1);
        }
        p.awarded = awarded;
      });

      history = history.concat(
        hPlaces.map(hp => ({
          place: w.rank,
          prize: hp.prize.name,
          winner: w.user.displayName,
          patronAccountNumber: w.patronAccountNumber,
          awarded: hp.awarded,
          wintime: w.wintime
        }))
      );
    });
  }

  drawing.awardHistory = history;
  places.forEach(p => {
    p.awarded = p.awarded || 'Unplayed';
  });

  if (!drawing.recurring) {
    drawing.recurringType = null;
    drawing.recurringId = null;
    drawing.recurringLastDrawingDateTime = null;
  } else {
    drawing.recurringLastDrawingDateTime = fromIso9075DateString(
      drawing.recurringLastDrawingDateTime
    );
  }

  drawing.timeLeft = timeLeft;
  drawing.winnersWithPlaces = winnersWithPlaces;
  drawing.prizeForRound = prizeForRound;
  drawing.prizesForRound = prizesForRound;
  drawing.prizesForRoundUniq = prizesForRoundUniq;
  drawing.claimedWinners = claimedWinners;
  drawing.placesWithPrizes = placesWithPrizes;
  return drawing;
};

//  ---------------------------------
export const cleanUpDrawing = drawing => {
  delete drawing.firstPrize;
  delete drawing.totalPlaces;
  delete drawing.currentRound;
  delete drawing.lastEvent;
  delete drawing.lastEventTimeMs;
  delete drawing.lastWinnerName;
  delete drawing.serverTimeDiff;
  delete drawing.timeLeft;
  delete drawing.winnersWithPlaces;
  delete drawing.prizeForRound;
  delete drawing.prizesForRound;
  delete drawing.awardHistory;
  delete drawing.claimedWinners;
  delete drawing.placesWithPrizes;
  return drawing;
};

//  ---------------------------------
// input UpdateDrawingInput {
//  id: Long!
//  name: String
//  url: String
//  description: String
//  enabled: Boolean
//  isCasinoverse: Boolean
//  drawTime: String
//  groupId: Int
//  disableGroupNotification: Boolean
//  groupUserMsg: String
//  disableNonGroupNotification: Boolean
//  nonGroupUserMsg: String
//  winningPlaces: DrawingWinPlaces
//  cmUserId: Long
// }

// input CreateDrawingInput {
//  name: String!
//  url: String
//  description: String
//  enabled: Boolean!
//  isCasinoverse: Boolean
//  drawTime: String!
//  groupId: Int
//  disableGroupNotification: Boolean
//  groupUserMsg: String
//  disableNonGroupNotification: Boolean
//  nonGroupUserMsg: String
//  winningPlaces: DrawingWinPlaces
//  cmUserId: Long!
// }

export const createDrawingMutationInput = (drawing, keepId = true) => {
  const input = { ...drawing };

  input.groupId =
    (input.group && input.group.groupId && parseInt(input.group.groupId)) ||
    null;
  delete input.group;

  input.winningPlaces = {
    winningPlaces: input.winningPlaces.winningPlaces.map(p => ({
      place: p.place,
      prizeId: p.prize.id
    }))
  };

  input.drawTime = getIso9075DateString(new Date(input.drawTime));
  input.customDrumClosedTime =
    !input.allTicketsAllowed && input.customDrumClosedTime
      ? getIso9075DateString(new Date(input.customDrumClosedTime))
      : null;
  input.cmUserId = parseInt(input.user.userId.replace(/[^0-9]/g, ''));
  delete input.user;

  if (!keepId) {
    delete input.id;
  }

  if (!input.recurring) {
    input.recurringType = null;
    input.recurringId = null;
    input.recurringLastDrawingDateTime = null;
  } else {
    if (input.recurringLastDrawingDateTime !== null) {
      input.recurringLastDrawingDateTime = getIso9075DateString(
        new Date(input.recurringLastDrawingDateTime)
      );
    }
  }

  delete input.lastModified;
  delete input.__typename;
  return input;
};

export const ticketsAuditSourceOptions = [
  'Adjustment',
  'WStorePurchase',
  'DrawingPrize',
  'TournamentPrize',
  'Event',
  'WheelWins',
  'HotelPromo',
  'LocationPromo',
  // 'AuctionBidRefund',  //  WCC-2052
  'UserFreeTicket',
  'AdminEntered',
  'UserEntered',
  'Refunded',
  'Reissued',
  'Removed',
  'Selected',
  'Won',
  'Ineligible',
  'QuestPrize',
  'Challenge',
  'BattleSlots',
  'UserRedeemed',
  'LedWall',
  'CasinoverseApp',
  'ExpressOffer',
  'PartyPlanner',
  'QRCodePromotion'
].map((lbl, idx) => ({ value: idx, label: lbl }));

export const ticketsSourceOptions = [
  'Adjustment',
  'WStorePurchase',
  'DrawingPrize',
  'TournamentPrize',
  'Event',
  'WheelWins',
  'HotelPromo',
  'LocationPromo',
  'UserFreeTicket',
  'QuestPrize',
  'Challenge',
  'BattleSlots',
  'UserRedeemed',
  'LedWall',
  'CasinoverseApp',
  'ExpressOffer',
  'PartyPlanner',
  'QRCodePromotion'
].map((lbl, idx) => ({ value: idx, label: lbl }));
